<div *ngIf="(pageVm$ | async) as pageVm">

    <app-page-header [vm]="pageVm" title='WWE Manifest' [fullHeader]="true" [canAddNew]="pageVm.canAddNew">
    </app-page-header>    

    <div *ngIf="pageVm.contentVm as vm">

        <!-- forms -->
        <div *ngIf="vm.formVm as fvm" class="mt-3">

            <!-- loading / error -->
            <div *ngIf="fvm.loadingError || (!fvm.loadingErrorText && fvm.loading)">
                <div class="row">
                    <div class="col-md-12 text-center">
                        <div *ngIf="fvm.loadingError" class="text-danger text-center">
                            <div>{{fvm.loadingErrorText}}</div>
                            <div>
                                <a class="underlined" href="javascript:null" (click)="formEnd(pageVm)">Back</a>
                            </div>
                        </div>
                        <div *ngIf="!fvm.loadingErrorText && fvm.loading">Loading...</div>
                    </div>
                </div>
            </div>

            <!-- not loading / no error -->
            <div *ngIf="!fvm.loading && !fvm.loadingError">

                <div class="row">
                    <div class="col-md-12">
                        <mdb-card narrower="true" cascade="true">
                            <div class="row">
                                <div class="col-md-6">
                                    <app-card-header [headingSize]="5" [title]="fvm.title">
                                    </app-card-header>
                                </div>
                            </div>
                            <mdb-card-body cascade="true">
                            
                                <!-- handle upload -->
                                <div *ngIf="fvm.type == 'handle-upload'">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <app-form-input [vm]="fvm.textInputVm" (textChanged)="handleUploadFormValidate(pageVm, vm, fvm)"></app-form-input>
                                        </div>
                                    </div>    
                                </div>

                                <!-- handle accept -->
                                <div *ngIf="fvm.type == 'handle-accept'">
                                    <div class="row">
                                        <div class="col-md-4">                                            
                                            <app-form-input *ngIf="fvm.resNumberInputVm" [vm]="fvm.resNumberInputVm" (textChanged)="handleAcceptFormValidate(pageVm, vm, fvm)"></app-form-input>
                                            <app-form-input [vm]="fvm.notesInputVm" (textChanged)="handleAcceptFormValidate(pageVm, vm, fvm)"></app-form-input>
                                        </div>
                                        <div class="col-md-8">
                                            <table mdbTable striped="true" small="true" *ngIf="fvm.fieldItemDisplayVm as fidvm">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">Field</th>
                                                        <th scope="col">Latest</th>
                                                        <th scope="col" *ngIf="fidvm.showPrevious">Previous</th>
                                                    </tr>
                                                </thead>            
                                                <tbody>
                                                    <tr mdbTableCol *ngFor="let f of fidvm.fieldItemVms">
                                                        <td><b>{{f.title}}</b></td>
                                                        <td [ngStyle]="{ width: fidvm.showPrevious ? '40%' : '75%' }">{{f.value}}</td>
                                                        <td style="width: 40%" *ngIf="fidvm.showPrevious" class="text-warning">
                                                            <ul *ngIf="f.previousValues.length > 1">
                                                                <li *ngFor="let pv of f.previousValues">{{pv}}</li>
                                                            </ul>
                                                            <span *ngIf="f.previousValues.length == 1">{{f.previousValues[0]}}</span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>                                        
                                        </div>
                                    </div>    
                                </div>

                                <!-- handle view -->
                                <div *ngIf="fvm.type == 'handle-view'">
                                    <div class="row">
                                        <div class="col-md-8">
                                            <table mdbTable striped="true" small="true" *ngIf="fvm.fieldItemDisplayVm as fidvm">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">Field</th>
                                                        <th scope="col">Latest</th>                                                        
                                                    </tr>
                                                </thead>            
                                                <tbody>
                                                    <tr mdbTableCol *ngFor="let f of fidvm.fieldItemVms">
                                                        <td><b>{{f.title}}</b></td>
                                                        <td>{{f.value}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>                                        
                                        </div>
                                    </div>    
                                </div>                                
                            
                            </mdb-card-body>
                        
                        </mdb-card>
                        <app-form-ok-cancel *ngIf="fvm.okCancelVm" [vm]="fvm.okCancelVm" [isInvalid]="!fvm.isValid"
                            (cancelClicked)="formEnd(pageVm)" (okClicked)="handleFormOk(pageVm, vm, fvm)">
                        </app-form-ok-cancel>
                    </div>
                </div>

            </div>

        </div>

        <!-- main content -->
        <div *ngIf="!vm.formVm" class="mt-3">
            
            <!-- tabs -->
            <div class="row" *ngIf="vm.data">
                <div class="col-md-12 pb-3">                    
                    <mdb-tabset #staticTabs [buttonClass]="'md-tabs blue-gradient'" [contentClass]="'card'">
                        <mdb-tab *ngFor="let tvm of vm.tabVms" [heading]="'Customer Manifest Handling'">

                            Coming Soon

                            <!-- <app-data-table-card [vm]="tvm.dataPanelVm" [showHeader]="false"
                                (rowActionClick)="rowActionInvoke(pageVm, vm, tvm, $event)">
                            </app-data-table-card> -->
                        </mdb-tab>
                    </mdb-tabset>                                        

                </div>
            </div>

        </div>
    </div>

</div>